/* global RamblerPlayer */
import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import PubSub from 'pubsub-js';

import { withRouter } from 'core/libs/router';

import loadScript from 'core/utils/load-script';
import { checkFreeHost, getPublisherScope } from 'core/utils/url-helper';
import { getCookie } from 'core/utils/cookie-helper';
import { puidsPropTypes } from 'core/utils/prop-types/ads';
import requestHeadersPropTypes from 'core/utils/prop-types/request-headers';
import withTopic from 'core/hocs/withTopic';

import { PLAYER_DOCK } from 'core/components/Video/constants';

import { USER_ID_COOKIE } from 'core/site/constants';

import styles from '../index.styl';

const RAMBLER_PLAYER = 'https://vp.rambler.ru/player/sdk.js';


function RamblerVideo(props, context) {
  const {
    videoId,
    puids,
    topic,
    location,
  } = props;

  const {
    requestHeaders: {
      host,
    },
    features,
  } = context;

  const playerVideo = useRef(null);

  const disableAutoplay = features.disableAutoplayOnFreeSubdomain
    && checkFreeHost(host);

  useEffect(() => {
    if (process.env.BROWSER_RUNTIME) {
      /**
       * Внутри бесконечного скролла текущий урл из роутера может быть
       * не верный. Поэтому для топика берем его из данных топика.
       */
      const referrerPathname = topic
        ? `${topic.content.attributes.link}`
        : location.pathname;

      loadScript(RAMBLER_PLAYER)
        .then(() => {
          window.RamblerPlayer = window.RamblerPlayer || [];
          window.RamblerPlayer.push(() => {
            const pleer = new RamblerPlayer({
              parent: playerVideo.current,
              id: videoId,
              sspJparams: puids,
              sspUserId: getCookie(USER_ID_COOKIE),
              sspUserIdScope: getPublisherScope(host),
              referrer: `https://${host}${referrerPathname}`,
              ...disableAutoplay && { autoPlay: false },
            });

            pleer.on(RamblerPlayer.Events.PLAYER_DOCK, isInDock => {
              PubSub.publish(PLAYER_DOCK, isInDock);
            });
          });
        })
        .catch(error => console.error(error.message));
    }

    return function cleanup() {
      PubSub.publish(PLAYER_DOCK, false);
    };
  // изменение videoId после инициализации компонента не предполагается
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disableAutoplay]);

  return <div ref={playerVideo} className={styles.video} />;
}

RamblerVideo.propTypes = {
  videoId: PropTypes.string,
  puids: puidsPropTypes,
  /** @ignore */
  topic: PropTypes.object,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};

RamblerVideo.contextTypes = {
  requestHeaders: requestHeadersPropTypes,
  features: PropTypes.shape({
    disableAutoplayOnFreeSubdomain: PropTypes.bool,
  }),
};

export default withRouter(withTopic(RamblerVideo));
